<template>
  <div class="grid grid-nogutter justify-content-center edge-padding page-wrapper" :style="'min-height: ' + (vuex.viewHeight - vuex.navFooterCombinedHeight + 10) + 'px;'">
    <div class="col-12 md:col-10 lg:col-10 flex-column">


      <div class="grid top-padding">
        <div class="wrapper center-text">
          <h2 class="top-padding">WHOLESALE ENQUIRIES</h2>
        </div>

        <div class="col-12">
          <div class="grid">

            <div v-if="!vuex.isMobile" class="col-12 mt-0 pb-0 lg:pb-0 pt-0 lg:pt-0 flex-order-0 text-center" data-aos="fade-right" data-aos-once="true">
              <img style="max-height:240px" :src="productsImage" class="bottom-padding"/>
            </div>
            <div v-if="vuex.isMobile" class="col-12 mt-0 pb-0 lg:pb-6 pt-0 lg:pt-6 flex-order-0 text-center" data-aos="fade-right" data-aos-once="true">
              <img style="width:100%" :src="productsImage" class="bottom-padding"/>
            </div>

<!--            <div class="col-12 mt-0 pb-0 lg:pb-6 flex-order-0 text-center" data-aos="fade-right" data-aos-once="true">
              <img class="img-border girls-image" :src="placeholderImage" style="border-radius: 5px; width: 100%; margin-top: 35px; max-width: 700px;"/>
              <p class="informational-text" style="font-size: 1.1rem;">Image caption.</p>
            </div>-->

            <div class="col-12 lg:col-8 flex-order-1 lg:pr-5" data-aos="fade-right" data-aos-once="true">

              <h2>Mānuka Honey in Bulk</h2>
              <p class="paragraph-text">We're thrilled to offer Wero New Zealand Mānuka Honey in bulk to wholesale buyers! As a family-owned business, we take pride in producing authentic, premium quality Mānuka honey from the pristine and remote areas of Aotearoa/New Zealand. Our honey is harvested with the utmost care for our bees and the land, ensuring the sustainability of both for future generations.</p>
              <p class="paragraph-text" style="display: none;">At Wero, we believe in authenticity, quality, and sustainability, and our wholesale offerings reflect these values. Our honey is independently tested and certified to meet the highest standards of quality, and is stored in temperature-controlled conditions to enhance its taste, quality, and MGO content.</p>
              <p class="paragraph-text">As a wholesale buyer, you'll have access to our delicious, top-quality Mānuka honey at competitive prices. Whether you're a retailer looking to stock your shelves with premium honey, or a food service provider seeking high-quality ingredients, we're here to meet your needs.</p>
              <p class="paragraph-text">To learn more about our wholesale offerings and to place an order, please get in touch with us. We look forward to working with you!</p>
              <div class="col-12 center-text lg:col-12 flex-order-1 lg:pb-6" style="display: flex; align-items: center" data-aos="fade-right" data-aos-once="true">
                <div v-if="!vuex.isMobile" style="margin: 0 0 6em 0;">
                  <Button @click="routeToContact()" label="Get in Touch Now" icon="pi pi-arrow-circle-right" iconPos="right" class="p-button-lg wero-button"></Button>
                </div>
              </div>

              <div class="col-12 center-text flex-order-0 pb-3 pt-3" data-aos="fade-down" data-aos-once="true">
                <Button v-if="vuex.isMobile" @click="routeToContact()" label="Get in Touch Now" class="p-button-lg wero-button fullwidth"></Button>
              </div>
            </div>

            <div class="col-12 lg:col-4 flex-order-1 lg:pr-5 pb-8 lg:pb-0" data-aos="fade-right" data-aos-once="true">
              <div class="flex justify-content-center flex-wrap card-container yellow-container">
                <img v-if="!vuex.isMobile" class="flex align-items-center justify-content-center img-border" :src="wholesaleImage" style="border-radius: 5px; margin-top: 35px; max-height: 400px; max-width: 100%"/>
                <img v-else class="flex align-items-center justify-content-center img-border" :src="wholesaleImage" style="border-radius: 5px; margin-top: 35px; max-width: 100%"/>
                <p class="informational-text" style="font-size: 1.1rem;">Miranda from the Wero Family.</p>
              </div>
            </div>

          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'Wholesale',

  components: {

  },

  mounted() {

  },

  data() {
    return {
      from_name: '',
      message: '',
      reply_to: '',
      placeholderImage: require("../assets/images/placeholderBanner.jpg"),
      productsImage: require("../assets/images/products-large.png"),
      wholesaleImage: require("../assets/images/wholesale-honey.jpg"),
    }
  },

  methods: {
    routeToContact: function() {
      // Change to about page - and scroll to top !
      this.$router.push({name: "Contact"});
      window.scrollTo(0, 0);
    },


  },

  computed: {
    vuex: function () {
      return(this.$store.state);
    },
  },

  watch: {

  }
}
</script>

<style scoped>

.wholesale-image{
  max-width: 100%;
}
.fullwidth{
  width:100%;
}

.wrapper{
  width: 100%
}

</style>
